import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "項目名稱",
    isNumber: true,
  },
];

export const EachProjectAnalysis = {
  label: "各項目分析",
  key: "EachProjectAnalysis",
  path: "Diabetes/EachProjectAnalysis",
  api: "TCS_V_Exam",
  render: (options) => <Diagram.Diabetes.EachProjectAnalysis {...options} />,
  isColSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  filterColumns: [{ key: "創建日期", type: "date" }],
  levelColumns,
  columns: [],
};
